export default __webpack_public_path__ + "static/media/pickup_done.08431c88.svg";